import React from 'react';

import useEmbeddedAPI from '@swf/core/hooks/useEmbeddedAPI';
import type { SpinOfDayData } from '@swf/core/types/CasinoBonus';
import { BonusStatus } from '@swf/core/types/CasinoBonus';
import { Category } from '@swf/core/types/StarsCoinReward';

import Container from '../Container/Container';
import type WithClose from '../WithClose';

import styles from './SpinOfTheDay.scss';
import Ticket from './components/Ticket/Ticket';

export type SotDGameDesc = Record<string, SpinOfDayData>;
interface Props extends WithClose {
  data?: SotDGameDesc;
}

const SpinOfTheDay: React.FC<Props> = ({ data, close }) => {
  const MAX_BONUSES_TO_DISPLAY = 3;
  const games: SpinOfDayData[] = data
    ? Object.values(data)
        .filter((bonus) => bonus.status !== BonusStatus.Paused)
        .sort((g1, g2) => {
          if (g1.expiryTime === g2.expiryTime) {
            if (g1.numberOfSpins === g2.numberOfSpins) {
              return g1.bonusId > g2.bonusId ? 1 : -1;
            } else {
              return g1.numberOfSpins < g2.numberOfSpins ? 1 : -1;
            }
          }
          return g1.expiryTime > g2.expiryTime ? 1 : -1;
        })
        .slice(0, MAX_BONUSES_TO_DISPLAY)
    : [];

  useEmbeddedAPI();

  return games.length > 0 ? (
    <Container category={Category.SpinOfDay} close={close}>
      <div className={styles.tickets}>
        {games.map((ticket, index) => (
          <Ticket key={index} data={ticket} layout={games.length} />
        ))}
      </div>
    </Container>
  ) : null;
};

export default SpinOfTheDay;
